import { render, staticRenderFns } from "./recovery.vue?vue&type=template&id=4e6c4fc8&scoped=true"
import script from "./recovery.vue?vue&type=script&lang=js"
export * from "./recovery.vue?vue&type=script&lang=js"
import style0 from "./recovery.vue?vue&type=style&index=0&id=4e6c4fc8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6c4fc8",
  null
  
)

export default component.exports